<template>
	<div class="w1">
	<div  class="Thematic_wrapper"><!-- Thematic_wrapper -->
				<el-skeleton :rows="30" :loading="loadingMask" animated >

						<div  class="group1 "><!-- group1 -->
							<div  class="group1_L " ><!-- group1_L -->
								
								<div  class="ZT_banner " ><!-- ZT_banner -->
									<!-- <div class="icon_dingyue" ></div>
									<a href=""><img :src="bannerdata" alt="" style="width: 638px;height: 292px;"/></a> -->
									<a @click="showDingyueDialog()" style="cursor: pointer;" name="D_Subscribe">
										<div class="btn_dingyue" >{{origindingyueList.length>0?'已订阅':'点击订阅'}}</div>
										<img :src="bannerdata" style="width: 638px;height: 292px;" alt=""/>
									</a>
								</div><!-- /ZT_banner -->
								
							</div><!-- /group1_L -->
							<div  class="group1_R  "><!-- group1_R -->
							
									
								<figure class="MyTabs Tabs2"><!-- MyTabs -->
								  <ul class="MyTabs-tabs">
									<!-- <li class="MyTabs-tab" :class="hotartType==0?'active':''"><a href="javascript:;" @click="hotartType=0" >专题热点</a></li> -->
									<li class="MyTabs-tab" :class="hotartType==1?'active':''"><a href="javascript:;" @click="hotartType=1" >推荐阅读</a></li>
								  </ul>
								  <div class="MyTabs-content"><!-- MyTabs-content -->
									<div v-show="hotartType==0" class="MyTabs-pane">
									  	<!-- <el-row class="zhuantireci" style="text-align: center;">
									  		<el-col :span="6" v-for="(item,index) in zhuantireci">
									  			<el-button @click="$router.push({ name: 'theme', params: { searchword: item , pagetype:'1' }})" :title="item">
									  				{{item.length>5?item.substring(0,5)+'...':item}}
									  			</el-button>
									  		</el-col>
									  	</el-row> -->
											<ul  class="ZThot_list"  >
												<li v-for="(item,index) in zhuantireci">
													<a @click="jumppush('/theme/'+item+'/1?col='+sourcecol)" :title="item" target="_blank">
														{{item}}
													</a>
												</li>
											</ul>
									</div>
									<div v-show="hotartType==1" class="MyTabs-pane">
									  	<ul  class="list1"  >
											<li v-for="item in hotartList"><a @click="jumppush('/detail/'+item.id+'?col='+sourcecol)" target="_blank">{{item.title}}</a></li>
											<!-- <li><a href=""  >国常会决定带量采购“提速扩面”，高值医用耗材纳入集采成趋势</a></li>
											<li><a href=""  >多地密集发布重大项目，新基建与新能源成为重要增长点</a></li>
											<li><a href=""  >IMF警示脆弱新兴经济体：即刻为潜在的经济动荡做准备</a></li>
											<li><a href=""  >刘和平：拜登对华科技战转向“精准脱钩”</a></li> -->
										</ul>
									</div>
								  </div><!-- /MyTabs-content -->
								</figure><!-- /MyTabs -->								
									
	
							</div><!-- /group1_R -->
						</div><!-- /group1 -->
						
						<div class="zhuanti-item-search">
							<itemsearch @showzixunjianyifromsearch="showfankui" v-bind:colid='colid' v-bind:colname='colname' v-bind:colfrom='sourcecol' v-bind:iszhuanti='1' @searchshow="searchshow" @searchclose="searchclose"></itemsearch>
						</div>
						
						<div class="m_b1"></div>
						
						<figure v-show="!searchResultShow" class="MyTabs Tabs1 " id="zhuantitabs"><!-- MyTabs -->
						
						  <ul class="MyTabs-tabs">
								<li @click="ztTabsChange('ff5a20cd26754e79bf27320c4b8c2f77',0,0)"
								:class="ztTabsId=='ff5a20cd26754e79bf27320c4b8c2f77'?'active':''" class="MyTabs-tab">
									<a href="javascript:;"  >报告解读</a>
								</li>
								<li @click="ztTabsChange('cc5e68ba1c094c50a250c42a259846d1',0,0)"
								:class="ztTabsId=='cc5e68ba1c094c50a250c42a259846d1'?'active':''" class="MyTabs-tab">
									<a href="javascript:;"  >高层动向</a>
								</li>
						  	<li @click="ztTabsChange('a89614fdb19a4ecc9df39e5f680a7027',0,0)"
						  	:class="ztTabsId=='a89614fdb19a4ecc9df39e5f680a7027'?'active':''" class="MyTabs-tab">
						  		<a href="javascript:;"  >经济发展成就</a>
						  	</li>
						  	<li @click="ztTabsChange('da806416c5aa4388a8b39224f7d137d4',0,0)"
						  	:class="ztTabsId=='da806416c5aa4388a8b39224f7d137d4'?'active':''" class="MyTabs-tab">
						  		<a href="javascript:;"  >产业发展成就</a>
						  	</li>
						  	<li @click="ztTabsChange('e0952030f323480eb00e9c4ba5eeca14',0,0)" 
						  	:class="ztTabsId=='e0952030f323480eb00e9c4ba5eeca14'?'active':''" class="MyTabs-tab">
						  		<a href="javascript:;"  >区域发展成就</a>
						  	</li>
								<li @click="ztTabsChange('2ac79f84e0e64506ae751e4def923da3',0,0)"
								:class="ztTabsId=='2ac79f84e0e64506ae751e4def923da3'?'active':''" class="MyTabs-tab">
									<a href="javascript:;"  >绿色发展成就</a>
								</li>
								<!-- <li @click="ztTabsChange('09c63ee302df46c59026e71a86659d71',0,0)"
								:class="ztTabsId=='09c63ee302df46c59026e71a86659d71'?'active':''" class="MyTabs-tab">
									<a href="javascript:;"  >外媒观点</a>
								</li> -->
								
						  </ul>
						  
						  <div class="MyTabs-content"><!-- MyTabs-content -->
							<div class="MyTabs-pane"><!-- MyTabs-pane -->
							 
								<template v-if="ztTabsType==0">
									<xwdt v-bind:ztsubid="ztTabsId" v-bind:sourcecol="sourcecol" v-bind:hasPower="hasPower" v-bind:showtype="ztTabsIsShowLabel" v-bind:areacode="searchArea"></xwdt>
								</template>
								<template v-else-if="ztTabsType==1">
									<zxsj v-bind:ztsubid="ztTabsId" v-bind:sourcecol="sourcecol" v-bind:hasPower="hasPower" v-bind:zxsjiframeurl="zxsjiframeurl"></zxsj>
								</template>
							 
							 
							</div><!-- /MyTabs-pane -->
						  </div><!-- /MyTabs-content -->
						  
						</figure><!-- /MyTabs -->

						
						
						<div class="m_b1"></div>
	
	
						
	
	
						
						</el-skeleton>
						
						
						
						<div v-show="showdingyue" class="Subscribe_Manage _popRight" id="SubscribeManage_pop" style="display: block;" ><!-- trial_apply -->
							<div class="pop_right"><!-- pop_right -->
								<ul class="pop_right_header2">
									<li><h2>订阅列表</h2></li>
									<li><btn class="pop_right_close2" name="pop-close" @click="cancelDingyuePanel"></btn></li>
								</ul>
								<div class="pop_right_main"><!-- main -->
									
									<div class='form-tips'><h4>订阅栏目后，可在推荐-专题订阅中查看最新数据</h4></div>
									
									<el-checkbox-group v-model="dingyueList">
										<el-checkbox v-for="(item,index) in subcolList" :label="item.columnid">{{item.columnname}}</el-checkbox>
									</el-checkbox-group>
						
									
						
									<div class="m_b1"></div>

								</div><!-- /main -->
								<div class="pop_right_footer2">
										<btn class="s_btn"  @click="saveUserOrders" >确定</btn>
								</div>
							</div><!-- /pop_right -->
							<div class="pop_bg" style="display: block;" @click="cancelDingyuePanel"></div>
						</div><!-- /trial_apply -->
						
						
								
					</div><!-- /Thematic_wrapper -->
					</div>
</template>

<script>
	import zxsj from '@/components/ztsz-zxsj.vue'
	import xwdt from '@/components/ztsz-xwdt.vue'
	import itemsearch from '@/components/list-item-search.vue'
	export default {
		data() {
			return {
				hasPower:true,
				loadingMask: false,
				colid:'8c165862d523425b8805a303bc4b4737',
				colname:'聚焦二十大',
				searchResultShow:false,
				bannerdata:'',
				timer:'',
				sourcecol:'ztjujiao',
				kanbanPageNo:1,
				kanbanPagePre:1,
				kanbanPageNext:1,
				kanbanPageTotal:1,
				kanbanList:[],
				ztTabsId:'ff5a20cd26754e79bf27320c4b8c2f77',
				ztTabsType:0,
				ztTabsIsShowLabel:0,
				hotartType:1,
				hotartList:[],
				tjyd:[],
				ztrw:[],
				zhuantireci:[],
				showdingyue:false,
				dingyueList:[],
				origindingyueList:[],
				origindingyuecount:0,
				subcolList:[],
				zxsjiframeurl:window.SITE_CONFIG.szjjzxsjIframeSrc,
			}
		},
		components: {
			zxsj,
			xwdt,
			itemsearch,
		},
		created:function(){
			this.bannerfnc();
			// this.kanbanfnc();
			this.tuijianfnc();
			// this.rewenfnc();
			// this.recifnc();
			this.getAllOrderCol();
		},
		mounted:function(){
			// this.$track();
			document.title='聚焦二十大-中经专网';
			this.$track([
				['pagetype','聚焦二十大专题'],
				['reqtype','2'],
				['column','8c165862d523425b8805a303bc4b4737']
			]);
			this.$track([
				['pagetype','聚焦二十大专题子栏目'],
				['reqtype','2'],
				['column',this.ztTabsId]
			]);
			// this.timer = setInterval(() => {
			// 	this.nextKBPage();
			// },10000);
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
			document.getElementsByTagName('body')[0].className = 'topbg2';
			this.authcheck();
		},
		destroyed:function(){
			document.getElementsByTagName('body')[0].className = 'topbg1';
		},
		computed: {

		},
		methods: {
			authcheck:function(){
				// this.hasPower=false;
				// if(!this.$cookies.get('userauth')){
				// 	this.hasPower=true;
				// }
				// else{
				// 	if(this.$cookies.get('userauth')=='1921f9e1416473a1d0f15d328e837115'){
				// 		this.hasPower=true;
				// 	}
				// 	if(this.$cookies.get('userauth').indexOf('ztjujiao')>-1){
				// 		this.hasPower=true;
				// 	}
				// }
			},
			jumppush:function(to){
				this.authcheck();
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			bannerfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'subject/selecImgtBycolumnID',
						responseType: 'json',
						params: {
							columnID: '8c165862d523425b8805a303bc4b4737',
						},
					})
					.then(function(response) {
						_this.bannerdata=response.data.data.data.images['8c165862d523425b8805a303bc4b4737'];
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
			kanbanfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'subject/getSubjectColumnArticles',
						responseType: 'json',
						params: {
							columnID: 'abe171b525444b4ca66ae4baf89d995b',
							iPage:'1',
							pageSize:'10',
							tagName:'看板',
						},
					})
					.then(function(response) {
						_this.kanbanList = response.data.data.data.data;
						if(_this.kanbanList&&_this.kanbanList.length>0){
							_this.kanbanPageTotal=Math.ceil(_this.kanbanList.length/2);
							_this.changeKBPage();
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMask = false;
					});
			},
			tuijianfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'subject/getXZWSubjectHotArticles',
						responseType: 'json',
						params: {
							cName:'聚焦二十大'
							// columnID: 'e2c387dd1ffd414eb70fb703be8f8a7a',
							// iPage:'1',
							// pageSize:'5'
						},
					})
					.then(function(response) {
						_this.hotartList=response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
			recifnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'subject/searchSubjectHotWord',
						responseType: 'json',
						params: {
							columnID: '05d1244eab64447084a17c6a47eafcb7',
							pageSize:'12'
						},
					})
					.then(function(response) {
						_this.zhuantireci=response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			preKBPage:function(){
				if(this.kanbanPageNo-1<1){
					this.kanbanPageNo=this.kanbanPageTotal;
				}
				else{
					this.kanbanPageNo--;
				}
				this.changeKBPage();
			},
			nextKBPage:function(){
				if(this.kanbanPageNo+1>this.kanbanPageTotal){
					this.kanbanPageNo=1;
				}
				else{
					this.kanbanPageNo++;
				}
				this.changeKBPage();
			},
			changeKBPage:function(){
				this.kanbanPagePre=this.kanbanPageNo-1<1?this.kanbanPageTotal:this.kanbanPageNo-1;
				this.kanbanPageNext=this.kanbanPageNo+1>this.kanbanPageTotal?1:this.kanbanPageNo+1;
			},
			zhuantiColumChange: function() {
			
			},
			ztTabsChange:function(id,type,showlabel){
				// debugger
				this.ztTabsId=id;
				this.ztTabsType=type;
				this.ztTabsIsShowLabel=showlabel;
				this.$track([
					['pagetype','聚焦二十大专题子栏目'],
					['reqtype','2'],
					['column',this.ztTabsId]
				]);
			},
			showDingyueDialog:function(){
				this.showdingyue=true;
				this.$track([
					['pagetype','聚焦二十大专题订阅'],
				]);
			},
			getAllOrderCol:function(){
				let _this = this;
				// _this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/selectAllOrderColByColumnID',
						responseType: 'json',
						params: {
							ColumnID:'8c165862d523425b8805a303bc4b4737'
						},
					})
					.then(function(response) {
						var tempdata=response.data.data.data;
						var tempchild=[];
						for(var i=0;i<tempdata.length;i++){
							if(tempdata[i].Child&&tempdata[i].Child.length>0){
								for(var j=0;j<tempdata[i].Child.length;j++){
									tempdata[i].Child[j].columnname=tempdata[i].columnname+'-'+tempdata[i].Child[j].columnname;
								}
								tempchild=tempchild.concat(tempdata[i].Child);
							}
						}
						if(tempchild.length>0){
							tempdata=tempchild;
						}
						var dingyuedata=tempdata;
						_this.origindingyueList=[];
						_this.origindingyuecount=0;
						for(var i=0;i<dingyuedata.length;i++){
							if(dingyuedata[i].ordertype=="1"){
								_this.origindingyueList.push(dingyuedata[i].columnid);
							}
						}
						_this.dingyueList = JSON.parse(JSON.stringify(_this.origindingyueList));
						_this.subcolList = dingyuedata;
						// _this.loadingMask = false;
					})
					.catch(function(error) {
						// _this.loadingMask = false;
						console.log(error);
					});
			},
			saveUserOrders:function(){
				var colidstring=this.dingyueList.join(',');
				let _this = this;
				// _this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/SaveUserColOrders',
						responseType: 'json',
						params: {
							rootColID:'8c165862d523425b8805a303bc4b4737',
							strColID:colidstring
						},
					})
					.then(function(response) {
						if(response.data.data.data.code=='0'){
							_this.$track([
								['pagetype','订阅修改'],
								['reqtype','3'],
								['column',_this.dingyueList.join(' ')]
							]);
							_this.$message({
								message: '订阅修改成功',
								type: 'success'
							});
							_this.showdingyue=false;
							_this.getAllOrderCol();
						}
						// _this.loadingMask = false;
					})
					.catch(function(error) {
						// _this.loadingMask = false;
						console.log(error);
					});
			},
			cancelDingyuePanel:function(){
				this.showdingyue=false;
				this.dingyueList = JSON.parse(JSON.stringify(this.origindingyueList));
				// for(var i=0;i<this.origindingyueList.length;i++){
				// 	this.$set(this.dingyueList[i],'selected',this.origindingyueList[i].selected);
				// }
				// console.log(this.dingyueList);
			},
			searchshow:function(key){
				this.searchResultShow=true;
			},
			searchclose:function(){
				this.searchResultShow=false;
			},
			showfankui:function(){
				this.$emit('showzixunjianyifromsearch');
			}
		}
	}
</script>

<style>
	
</style>
